<template>
  <div class="button-container" @click.stop="save">
    <v-slide-y-reverse-transition>
      <div v-show="visible" v-ripple class="button pill" :style="buttonStyle">
        <div class="layout justify-center align-center fill-height no-wrap">
          <div v-if="icon" class="mr-2">
            <v-icon :style="iconStyle">
              {{ icon }}
            </v-icon>
          </div>
          <div class="label">
            {{ label }}
          </div>
        </div>
      </div>
    </v-slide-y-reverse-transition>
  </div>
</template>

<script>
export default {
  name: 'AddContentButton',
  props: {
    type: String,
    disabled: Boolean,
    icon: String,
    label: String,
    visible: Boolean
  },
  data() {
    return {
      dialog: false
    };
  },
  computed: {
    iconStyle() {
      return {
        color: !this.disabled ? 'white' : 'black'
      };
    },
    buttonStyle() {
      return {
        backgroundColor: !this.disabled ? 'var(--lightish-blue)' : '#f5f5f5',
        color: !this.disabled ? 'white' : 'black'
      };
    }
  },
  methods: {
    save(e) {
      return this.$emit('click', e);
    }
  }
};
</script>

<style scoped>
.button-container {
  bottom: 0px;
  width: 100%;
  left: 0;
  background-image: linear-gradient(to bottom, rgba(255, 0, 0, 0), rgba(255, 255, 255, 1));

  margin: 0px auto;
  z-index: 1001;
  position: absolute;
}
.button {
  width: 163px;
  height: 40px;
  margin-bottom: 10px;
  margin: 10px auto;
  border-radius: 20px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 8px 0 rgba(0, 0, 0, 0.2);
  background-color: var(--lightish-blue);
  color: white !important;
  cursor: pointer;
}
</style>
